import { render } from "./table-modal-area.vue?vue&type=template&id=6d8066b0&scoped=true&ts=true"
import script from "./table-modal-area.vue?vue&type=script&lang=ts"
export * from "./table-modal-area.vue?vue&type=script&lang=ts"

import "./table-modal-area.vue?vue&type=style&index=0&id=6d8066b0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8066b0"]])

export default __exports__